import { APP_CONSTANTS } from 'src/app/constants/constants';
import { Component, Input, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import * as ApexCharts from 'apexcharts';

@Component({
	selector: 'app-advisor-profile-sales-history',
	templateUrl: './advisor-profile-sales-history.component.html',
	styleUrls: ['./advisor-profile-sales-history.component.scss']
})
export class AdvisorProfileSalesHistoryComponent implements OnInit {
  APP_CONSTANTS = APP_CONSTANTS;

  @Input() advisor_data_id: any;
  selected_period: any = 'last 6 months';
  page_loaded: boolean = false;
  page_data: any;

  constructor(
    private storageService: StorageService,
    public commonService: CommonService,
  ) {}

  ngOnInit(): void {
    this.getGraphData();
  }

  getGraphData() {
    this.page_loaded = false;
    this.commonService
      .getData(
        '/advisorpastperformance/?id=' +
          this.advisor_data_id +
          '&duration=' +
          this.selected_period,
      )
      .subscribe(
        (res: any) => {
          this.page_data = res['data'];

          this.page_loaded = true;
          setTimeout(() => {
            this.createSalesGraphs();
            this.createProductGraphs();
            this.createCustomerGraphs();
          }, 200);
        },
        (err) => {
          this.commonService.showToast('error', err.error);
          this.page_loaded = true;
        },
      );
  }

  years_list: any = [];
  getYears() {
    let current_year = new Date().getFullYear();
    for (let index = 0; index < 10; index++) {
      this.years_list.push(current_year);
      current_year = current_year - 1;
    }
  }

  show_sales_graphs: boolean = true;
  createSalesGraphs() {
    if (this.show_sales_graphs == true) {
      setTimeout(() => {
        this.createSalesAmountGraph();
        this.createSalesCountGraph();
        this.createSalesTypeGraph();
      }, 200);
    }
  }

  createSalesAmountGraph() {
    let $this = this;
    var options = {
      colors: '#55A1EF',
      series: [
        {
          name: '',
          data: $this.page_data['performance_aum']['y-axis'],
        },
      ],
      chart: {
        type: 'bar',
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
        height: 300,
      },
      noData: {
        text: 'No Data Available',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#006AFF',
          fontSize: '24px',
          fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '45%',
          endingShape: 'rounded',
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 0,
        colors: ['transparent'],
      },
      xaxis: {
        categories: $this.page_data['performance_aum']['x-axis'],
        title: {
          // text: 'Months'
        },
        crosshairs: {
          show: false,
        },
      },
      yaxis: {
        title: {
          text: 'Amount',
        },
        labels: {
          // formatter: function (value) {
          //   let val: string | number = Math.abs(value);
          //   if (val >= 10 ** 3 && val < 10 ** 6) {
          //     val = (val / 1000).toFixed(0) + 'K';
          //   } else if (val >= 10 ** 6) {
          //     val = (val / 1000000).toFixed(0) + 'M';
          //   } else {
          //     val = val;
          //   }
          //   return val;
          // },
          formatter: (value: number) => {
            return this.commonService.labelFormatter(value);
          }
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return APP_CONSTANTS.CURRENCY_SYMBOL + ' ' + val.toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT);
          },
        },
      },
    };

    var chart = new ApexCharts(
      document.querySelector('#sales-amount-graph'),
      options,
    );
    chart.render();
  }

  createSalesCountGraph() {
    let $this = this;
    var options = {
      colors: '#55A1EF',
      series: [
        {
          name: '',
          data: $this.page_data['sales_count']['y-axis'],
        },
      ],
      chart: {
        type: 'bar',
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
        height: 300,
      },
      noData: {
        text: 'No Data Available',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#006AFF',
          fontSize: '24px',
          fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '45%',
          endingShape: 'rounded',
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 0,
        colors: ['transparent'],
      },
      xaxis: {
        categories: $this.page_data['sales_count']['x-axis'],
        title: {
          // text: 'Quarters'
        },
        crosshairs: {
          show: false,
        },
      },
      yaxis: {
        title: {
          text: 'Count',
        },
        labels: {
          // formatter: function (value) {
          //   let val: string | number = Math.abs(value);
          //   if (val >= 10 ** 3 && val < 10 ** 6) {
          //     val = (val / 1000).toFixed(0) + 'K';
          //   } else if (val >= 10 ** 6) {
          //     val = (val / 1000000).toFixed(0) + 'M';
          //   } else {
          //     val = val;
          //   }
          //   return val;
          // },
          formatter: (value: number) => {
            return this.commonService.labelFormatter(value);
          }
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val;
          },
        },
      },
    };

    var chart = new ApexCharts(
      document.querySelector('#sales-count-graph'),
      options,
    );
    chart.render();
  }

  createSalesTypeGraph() {
    let $this = this;
    var options = {
      // colors: "#55A1EF",
      series: $this.page_data['clients_by_type']['y-axis'],
      chart: {
        type: 'bar',
        stacked: true,
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
        height: 300,
      },
      noData: {
        text: 'No Data Available',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#006AFF',
          fontSize: '24px',
          fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '45%',
          endingShape: 'rounded',
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 0,
        colors: ['transparent'],
      },
      xaxis: {
        categories: $this.page_data['clients_by_type']['x-axis'],
        title: {
          // text: 'Years'
        },
        crosshairs: {
          show: false,
        },
      },
      yaxis: {
        title: {
          text: 'Amount',
        },
        labels: {
          // formatter: function (value) {
          //   let val: string | number = Math.abs(value);
          //   if (val >= 10 ** 3 && val < 10 ** 6) {
          //     val = (val / 1000).toFixed(0) + 'K';
          //   } else if (val >= 10 ** 6) {
          //     val = (val / 1000000).toFixed(0) + 'M';
          //   } else {
          //     val = val;
          //   }
          //   return val;
          // },
          formatter: (value: number) => {
            return this.commonService.labelFormatter(value);
          }
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val;
          },
        },
      },
    };

    var chart = new ApexCharts(
      document.querySelector('#sales-type-graph'),
      options,
    );
    chart.render();
  }

  show_product_graphs: boolean = true;
  createProductGraphs() {
    if (this.show_product_graphs == true) {
      setTimeout(() => {
        this.createProductGroupGraph();
        this.createProductGraph();
      }, 200);
    }
  }

  createProductGroupGraph() {
    let $this = this;
    var options = {
      series: $this.page_data['clients_by_productgroup']['y-axis'],
      chart: {
        type: 'bar',
        stacked: true,
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
        height: 300,
      },
      noData: {
        text: 'No Data Available',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#006AFF',
          fontSize: '24px',
          fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '45%',
          endingShape: 'rounded',
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 0,
        colors: ['transparent'],
      },
      xaxis: {
        categories: $this.page_data['clients_by_productgroup']['x-axis'],
        title: {
          // text: 'Years'
        },
        crosshairs: {
          show: false,
        },
      },
      yaxis: {
        title: {
          text: 'Count',
        },
        labels: {
          // formatter: function (value) {
          //   let val: string | number = Math.abs(value);
          //   if (val >= 10 ** 3 && val < 10 ** 6) {
          //     val = (val / 1000).toFixed(0) + 'K';
          //   } else if (val >= 10 ** 6) {
          //     val = (val / 1000000).toFixed(0) + 'M';
          //   } else {
          //     val = val;
          //   }
          //   return val;
          // },
          formatter: (value: number) => {
            return this.commonService.labelFormatter(value);
          }
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val;
          },
        },
      },
    };

    var chart = new ApexCharts(
      document.querySelector('#product-group-graph'),
      options,
    );
    chart.render();
  }

  createProductGraph() {
    let $this = this;
    var options = {
      series: $this.page_data['clients_by_product']['y-axis'],
      chart: {
        type: 'bar',
        stacked: true,
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
        height: 300,
      },
      noData: {
        text: 'No Data Available',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#006AFF',
          fontSize: '24px',
          fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '45%',
          endingShape: 'rounded',
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 0,
        colors: ['transparent'],
      },
      xaxis: {
        categories: $this.page_data['clients_by_product']['x-axis'],
        title: {
          // text: 'Years'
        },
        crosshairs: {
          show: false,
        },
      },
      yaxis: {
        title: {
          text: 'Count',
        },
        labels: {
          // formatter: function (value) {
          //   let val: string | number = Math.abs(value);
          //   if (val >= 10 ** 3 && val < 10 ** 6) {
          //     val = (val / 1000).toFixed(0) + 'K';
          //   } else if (val >= 10 ** 6) {
          //     val = (val / 1000000).toFixed(0) + 'M';
          //   } else {
          //     val = val;
          //   }
          //   return val;
          // },
          formatter: (value: number) => {
            return this.commonService.labelFormatter(value);
          }
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val;
          },
        },
      },
    };

    var chart = new ApexCharts(
      document.querySelector('#product-graph'),
      options,
    );
    chart.render();
  }

  show_customer_graphs: boolean = true;
  createCustomerGraphs() {
    if (this.show_customer_graphs == true) {
      setTimeout(() => {
        // this.createFinancialSegmentGraph();
        this.createDemographicGroupGraph();
        this.createCustomerAUMGraph();
      }, 200);
    }
  }

  createFinancialSegmentGraph() {
    let $this = this;
    var options = {
      series: $this.page_data['clients_by_segment']['y-axis'],
      chart: {
        type: 'bar',
        stacked: true,
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
        height: 300,
      },
      noData: {
        text: 'No Data Available',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#006AFF',
          fontSize: '24px',
          fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '45%',
          endingShape: 'rounded',
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 0,
        colors: ['transparent'],
      },
      xaxis: {
        categories: $this.page_data['clients_by_segment']['x-axis'],
        title: {
          // text: 'Years'
        },
        crosshairs: {
          show: false,
        },
      },
      yaxis: {
        title: {
          text: 'Count',
        },
        labels: {
          // formatter: function (value) {
          //   let val: string | number = Math.abs(value);
          //   if (val >= 10 ** 3 && val < 10 ** 6) {
          //     val = (val / 1000).toFixed(0) + 'K';
          //   } else if (val >= 10 ** 6) {
          //     val = (val / 1000000).toFixed(0) + 'M';
          //   } else {
          //     val = val;
          //   }
          //   return val;
          // },
          formatter: (value: number) => {
            return this.commonService.labelFormatter(value);
          }
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val;
          },
        },
      },
    };

    var chart = new ApexCharts(
      document.querySelector('#financial-segment-graph'),
      options,
    );
    chart.render();
  }

  createDemographicGroupGraph() {
    let $this = this;
    var options = {
      series: $this.page_data['clients_by_demographicgroup']['y-axis'],
      chart: {
        type: 'bar',
        stacked: true,
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
        height: 300,
      },
      noData: {
        text: 'No Data Available',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#006AFF',
          fontSize: '24px',
          fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '45%',
          endingShape: 'rounded',
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 0,
        colors: ['transparent'],
      },
      xaxis: {
        categories: $this.page_data['clients_by_demographicgroup']['x-axis'],
        title: {
          // text: 'Years'
        },
        crosshairs: {
          show: false,
        },
      },
      yaxis: {
        title: {
          text: 'Count',
        },
        labels: {
          // formatter: function (value) {
          //   let val: string | number = Math.abs(value);
          //   if (val >= 10 ** 3 && val < 10 ** 6) {
          //     val = (val / 1000).toFixed(0) + 'K';
          //   } else if (val >= 10 ** 6) {
          //     val = (val / 1000000).toFixed(0) + 'M';
          //   } else {
          //     val = val;
          //   }
          //   return val;
          // },
          formatter: (value: number) => {
            return this.commonService.labelFormatter(value);
          }
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val;
          },
        },
      },
    };

    var chart = new ApexCharts(
      document.querySelector('#demographic-group-graph'),
      options,
    );
    chart.render();
  }

  createCustomerAUMGraph() {
    let $this = this;
    var options = {
      colors: '#55A1EF',
      series: [
        {
          name: '',
          data: $this.page_data['no_of_clients']['y-axis'],
        },
      ],
      chart: {
        type: 'bar',
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
        height: 300,
      },
      noData: {
        text: 'No Data Available',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#006AFF',
          fontSize: '24px',
          fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '45%',
          endingShape: 'rounded',
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 0,
        colors: ['transparent'],
      },
      xaxis: {
        categories: $this.page_data['no_of_clients']['x-axis'],
        title: {
          // text: 'Years'
        },
        crosshairs: {
          show: false,
        },
      },
      yaxis: {
        title: {
          text: 'Count',
        },
        labels: {
          // formatter: function (value) {
          //   let val: string | number = Math.abs(value);
          //   if (val >= 10 ** 3 && val < 10 ** 6) {
          //     val = (val / 1000).toFixed(0) + 'K';
          //   } else if (val >= 10 ** 6) {
          //     val = (val / 1000000).toFixed(0) + 'M';
          //   } else {
          //     val = val;
          //   }
          //   return val;
          // },
          formatter: (value: number) => {
            return this.commonService.labelFormatter(value);
          }
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val;
          },
        },
      },
    };

    var chart = new ApexCharts(
      document.querySelector('#customer-aum-graph'),
      options,
    );
    chart.render();
  }
}
